/* eslint-disable no-console */
import buildErrorObject from 'utils/buildErrorObject';
import { FAILURE, REQUEST } from 'utils/generateConstantLifecycle';

import * as actions from './actions';
import { CREATE_ERROR, DELETE_ERROR } from './constants';
import * as reactions from './reactions';
import * as reducers from './reducers';
import * as selectors from './selectors';

export * from './constants';

export default {
  getMiddleware: () => (store) => (next) => (action) => {
    // If a failure type is dispatched in the app, record it in state
    try {
      const { dispatch } = store;
      const { type = '', error } = action;
      // Remove _REQUEST / _FAILURE from type before we store it or remove it
      const scrubbedType = type.split('_').slice(0, -1).join('_');

      if (typeof type === 'string') {
        // dispatch removing error from errors store
        if (type.endsWith(`_${REQUEST}`)) {
          // if there is an error of a matching type
          const state = store.getState();
          const { [scrubbedType]: errorMatch } = store.selectErrors(state);

          // clear the error
          if (errorMatch)
            dispatch({ payload: { type: scrubbedType }, type: DELETE_ERROR });
        }

        // dispatch error to errors store
        if (type.endsWith(`_${FAILURE}`)) {
          dispatch({
            payload: { error: buildErrorObject(error), type: scrubbedType },
            type: CREATE_ERROR,
          });
        }

        return next(action);
      }
    } catch (err) {
      console.warn(`Error in error handling middleware: ${err}`);
      return next(action);
    }
    return next(action);
  },
  ...actions,
  ...reducers,
  ...selectors,
  ...reactions,
  name: 'errors',
};
